export default __webpack_public_path__ + "static/media/lighting_electrical.8bd3a915.svg";